const initialState = {
  sectionsList: [],
  currentSection: 0,
  questionsHistory: [],
  currentQuestion: 0,
  branchingLogics: [],
  numberOfNewSections: 0
}

export default initialState
